<template>
  <v-dialog
    v-model="isDialogOpen"
    scrollable
    content-class="ma-2"
    :max-width="540"
    :persistent="true"
  >
    <v-card class="pa-0 redirect-dialog">
      <div class="dialog-title-container">
        <h2 class="dialog-title">Re-directing</h2>
      </div>

      <v-divider></v-divider>

      <v-card-text class="dialog-content-container">
        <div>
          <div class="dialog-content">
            <div>
              <p>
                We need you to give us a few pieces of information before you
                can get a new quote.
              </p>
            </div>
            <div>
              <p>
                You're now being re-directed to our referral form, please
                wait...
              </p>
            </div>
            <div>
              <p>
                If you haven't been re-directed automatically in 30 seconds,
                please click the button below.
              </p>
            </div>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 36px">
            <div style="width: 420px" class="mx-10">
              <BaseButton
                text="CONTINUE"
                rounded
                block
                class="font-weight-bold"
                height="60"
                :color="'#fab519'"
                :textColor="'primary--text'"
                :fontSize="'font-20'"
                @click="redirect"
              />
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "RedirectDialog",
  data() {
    return {
      isDialogOpen: true,
    };
  },
  components: {
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
  },
  mounted() {
    setTimeout(() => {
      this.redirect();
    }, 30000);
  },
  methods: {
    redirect() {
      window.location.href = process.env.VUE_APP_PSL_IA_URL + "/introducer";
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-content {
  height: 200px;
  margin: 0 40px 0 37px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;

  p {
    font-size: 16px;
    color: #272727;
    margin-bottom: 0;
    letter-spacing: 0.4px;
    line-height: normal;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
  }
}
.block-header {
  font-weight: bold;
}

.redirect-dialog {
  border-radius: 20px;
  .dialog-title-container {
    margin: 35px 37px 23.8px;
    .dialog-title {
      font-size: 28px;
      color: #272727;
      font-weight: bold;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
    }
  }
  .dialog-content-container {
    padding: 20.8px 0 40px 0;
  }
}
</style>
